import React, { Component } from 'react'
import styled from 'styled-components'
import { Image } from 'pcln-design-system'
import PropTypes from 'prop-types'
import airTheme from '../AirThemeProvider/airTheme'
import AirlineImageSvg from './AirlineImageSvg'

/**
 * Added '!important' as DS Image component display style is overriding the
 * inline-block of the image component
 * */

const LogoImage = styled(Image)`
  display: inline-block !important;
  margin: auto 0;
  width: 24px;
  max-height: 24px;
  vertical-align: middle;
  ${airTheme.flyQueries.tablet} {
    width: ${(props) => (props.covidAttrsDetails ? '24px' : '32px')};
    max-height: 36px;
  }
`

const FallbackSVG = styled(AirlineImageSvg)`
  display: inline-block;
  margin: auto 0;
  width: 24px;
  max-height: 24px;
  vertical-align: middle;

  ${airTheme.flyQueries.tablet} {
    width: 32px;
    height: 100%;
    max-height: 36px;
  }
`

export default class AirlineImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fallbackImage: false,
    }
  }

  setErrorImage() {
    this.setState({
      fallbackImage: true,
    })
  }

  render() {
    const { airlineLogo, airlineName, className, covidAttrsDetails } = this.props
    const { fallbackImage } = this.state
    const classNames = className + ' hero-image'

    /* istanbul ignore next */
    const imageUrl = `https://s1.pclncdn.com/design-assets/fly/carrier-logos/${airlineLogo}?opto&auto=webp&height=32&width=38`
    return !fallbackImage ? (
      <LogoImage
        data-testid='airline-logo'
        covidAttrsDetails={covidAttrsDetails}
        alt={`${airlineName} logo`}
        src={imageUrl}
        onError={(e) => this.setErrorImage(e)}
        className={classNames}
        loading='lazy'
      />
    ) : (
      <FallbackSVG airlineName={airlineName} className={classNames} />
    )
  }
}

AirlineImage.propTypes = {
  airlineLogo: PropTypes.string.isRequired,
  airlineName: PropTypes.string.isRequired,
  className: PropTypes.string,
  covidAttrsDetails: PropTypes.bool,
}
